module.exports = __webpack_public_path__ + "img/circle3green.ce85c7de.png";